<div class="checkbox" [class.selected]="selected === true">
  <div class="selection-indicator" *ngIf="selected !== undefined">
    <svg viewBox="0 0 24 24">
      <path fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
    </svg>
  </div>
</div>